import { PrimaryButton, Button, ButtonRow, ErrorNotification } from '@cb/apricot-react'
import DINameAddress from './DINameAddress'
import {
  useUserDetailsQuery,
  useEducationPeriodsQuery,
  useStudentScoreSendQuery,
  useDeleteStudentScoreSendMutation,
} from '../../hooks'
import { STATUS_LOADING, STATUS_ERROR } from '../_common/reactquery'

function DisplayDI({ selectedDI, setIsEditing, setDICodeSelection, setBackupDICodeSelection }) {
  // User Details
  const { data: userDetails = {}, isLoading: isLoadingUserDetails } = useUserDetailsQuery()
  const { studentId } = userDetails
  // Education Periods
  const { data: educationPeriodsData = {} } = useEducationPeriodsQuery({
    id: studentId,
    myDetailsComplete: !isLoadingUserDetails,
  })
  const { currentEducationPeriod = {} } = educationPeriodsData
  // Score Send
  const { data: scoreSendData = {} } = useStudentScoreSendQuery({
    educationPeriodCd: currentEducationPeriod?.code,
  })

  const { mutate: deleteScoreSendDI, status } = useDeleteStudentScoreSendMutation({
    educationPeriodCd: currentEducationPeriod?.code,
  })
  const { org } = scoreSendData

  if (!org?.dicode) return null

  const handleClickEdit = () => {
    setBackupDICodeSelection(selectedDI)
    setDICodeSelection({})
    setIsEditing(true)
  }

  const handleClickDelete = () => {
    deleteScoreSendDI(
      {
        educationPeriodCd: currentEducationPeriod?.code,
      },
      { onSuccess: () => setDICodeSelection({}) }
    )
  }

  return (
    <div className="cb-margin-top-24 cb-margin-bottom-24">
      {status === STATUS_ERROR ? (
        <ErrorNotification className="cb-margin-bottom-24" title="Error">
          Error deleting data. Please try again later.
        </ErrorNotification>
      ) : null}
      <DINameAddress org={org} />
      <ButtonRow>
        <PrimaryButton disabled={status === STATUS_LOADING} onClick={handleClickEdit}>
          Edit
        </PrimaryButton>
        <Button onClick={handleClickDelete} disabled={status === STATUS_LOADING}>
          Remove
        </Button>
      </ButtonRow>
    </div>
  )
}

export default DisplayDI
